import React, { useState, useEffect } from "react";
import {
    Typography,
    Box,
    Modal,
} from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";


export default function WebMultipleSelectBook({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const availableChoices = data.choices;

    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [answer, setAnswer] = useState([]);
    const [modalImage, setModalImage] = useState(null);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setModalOpen(false);
        setModalContent(null);
        setAnswer([]);
        setModalImage(null);
    }, [question]);

    const handleImageClick = (modalInfo, modalImage) => {
        setModalContent(modalInfo);
        setModalImage(modalImage);
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false);
    };

    const handleChoiceClick = (choice) => {
        let ans = [...answer];
        if (answer.indexOf(choice.value) > -1) {
            removeChoice(choice.value);
        } else {
            if (!data.multiple && ans.length > 0) { // single if not exist set to empty
                setAnswer([]);
            }

            ans = [
                ...ans,
                choice.value,
            ];

            setAnswer(ans);
            checkCanProceed(ans);
        }
    }

    const checkCanProceed = (ans) => {
        const canProceed = ans.length > 0;

        const finalAnswer = data.multiple ? ans : (ans[0] ?? "");

        onAnswer({
            canProceed,
            answer: finalAnswer,
        });
    }

    const removeChoice = (value) => {
        let newAnswer = [...answer];
        let index = newAnswer.indexOf(value)
        if (index !== -1) {
            newAnswer.splice(index, 1);
            setAnswer(newAnswer);
        }

        checkCanProceed(newAnswer);
    }

    return (
        <React.Fragment>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                width: "100%",
                height: "340px",
                textAlign: "center",
            }}>
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    textAlign: "center",
                }}>
                    {availableChoices.map((choice, index) => (
                        <Box key={index} sx={{
                            position: "relative",
                            width: "203px",
                            height: "280px",
                        }}>
                            <Box component="img" 
                                src={`${imagesResources}${choice.image}`}
                                sx={{
                                    textAlign: "center"
                                }}
                                alt={`Img choice img ${index}`}
                            />
                            <Box component="img"
                                src={`${imagesResources}${choice.viewBtn}`}
                                sx={{
                                    position: "absolute",
                                    top: "-10px",
                                    right: "-10px",
                                    cursor: "pointer",
                                    textAlign: "center",
                                }}
                                onClick={() =>
                                    handleImageClick(choice.modalInfo, choice.image)
                                }
                                alt={`Img btn img ${index}`}
                            />
                        </Box>
                    ))}
                </Box>
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    textAlign: "center",
                }}>
                    {availableChoices.map((choice, index) => (
                        <Box key={index} 
                            component="span"
                            sx={{
                                width: "200px",
                                height: "40px",
                                display: "inline-table",
                                cursor: "pointer",
                                userSelect: "none",
                                backgroundColor: answer.includes(choice.value) ? "#afe23e" : "#dadada",
                                borderBottom: answer.includes(choice.value) ? "10px solid #639729" : "10px solid #808080",
                                fontWeight: "bold",
                                textAlign: "center",
                                fontSize: "18px",
                            }}
                            onClick={() =>
                                handleChoiceClick(choice)
                        }>
                            <Box component="span"
                                style={{
                                    display: "table-cell",
                                    verticalAlign: "middle",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }
                            }>{answer.includes(choice.value) ? 'Selected' : 'Select This Book'}</Box>
                        </Box>
                    ))}
                </Box>
            </Box>
            {/* Modal */}
            <Modal
                open={modalOpen}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: {
                            xs: "50%",
                            sm: "48%",
                            md: "45%",
                            lg: "50%",
                        },
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: {
                            xs: "90%",
                            sm: "600px",
                            md: "750px",
                            lg: "900px",
                        },
                        maxWidth: "900px",
                        backgroundColor: "white",
                        boxShadow: 24,
                        padding: 0,
                        borderBottom: "10px solid rgb(0, 132, 180)",
                        overflowY: "auto",
                        maxHeight: "90vh",
                    }}
                >
                    {/* Modal Header */}
                    <Box
                        sx={{
                            backgroundColor: "rgb(0, 176, 240)",
                            color: "black",
                            padding: "8px 20px",
                            fontSize: "1.25em",
                            textAlign: "left",
                            borderBottom: "10px solid rgb(0, 132, 180)",
                            boxSizing: "border-box",
                            position: "relative",
                            height: "60px",
                        }}
                    >
                        <Typography
                            id="modal-title"
                            variant="h1"
                            sx={{ fontSize: "30px", fontWeight: "700" }}
                        >
                            {modalContent?.title}
                        </Typography>
                        {/* Close Image */}
                        <Box component="img"
                            src={`${imagesResources}learning-l4q2a-5.png`}
                            alt="Close"
                            sx={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                                width: "32px",
                                height: "32px",
                            }}
                            onClick={handleClose}
                        />
                    </Box>

                    {/* Modal Description */}
                    <Box sx={{ padding: "0px 16px 16px 16px" }}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                            fontSize: "24px",
                        }}>
                            <Box sx={{
                                display: "flex",
                                minWidth: "203px",
                            }}>
                                <Box component="img" 
                                    src={`${imagesResources}${modalImage}`}
                                    sx={{
                                        alignSelf: "center",
                                        width: "100%",
                                    }}
                                />
                            </Box>
                            <Box sx={{ margin: "auto 20px" }}>
                                {(modalContent) && modalContent.map((info, index) => {
                                    const Tag = info.type;
                                    return (
                                        <Tag key={index} style={info.style}>{info.value}</Tag>
                                    )
                                })}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </React.Fragment>
    );
};